/**
 * ConfirmPasswordForm.jsx
 * Created by michaelbray on 2/13/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import PasswordStrengthIndicator from '../../../../components/sharedComponents/PasswordStrengthIndicator';
import Label from '../../../sharedComponents/Label';
import Button from '../../../sharedComponents/Button';
import { FlexCol, FlexRow } from '../../../sharedComponents/FlexGrid';
import * as Icons from '../../../sharedComponents/icons/Icons';
import Heading from '../../../sharedComponents/Heading';

const propTypes = {
    label: PropTypes.string,
    errorText: PropTypes.string,
    confirmPasswords: PropTypes.func
};

export default class ConfirmPasswordForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            password1: '',
            password2: '',
            disabled: false
        };

        this.password1TextChange = this.password1TextChange.bind(this);
        this.password2TextChange = this.password2TextChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    componentDidMount() {
        this.password1.focus();
    }


    password1TextChange(e) {
        this.setState({
            password1: e.target.value
        });
    }

    password2TextChange(e) {
        this.setState({
            password2: e.target.value
        });
    }

    submitForm(e) {
        e.preventDefault();
        this.setState({
            disabled: true
        }, this.props.confirmPasswords({
            password1: this.state.password1,
            password2: this.state.password2
        }));
    }

    render() {
        let error = null;
        let disabled = this.state.disabled;

        if (this.props.errorText) {
            disabled = false;
            error = (
                <div className="rec-notification-error">
                    <span className="rec-notification-icon">
                        <Icons.IconWarning />
                    </span>
                    <div className="rec-notification-body">
                        <p>{this.props.errorText}</p>
                    </div>
                </div>
            );
        }

        return (
            <FlexRow justifyContent="center">
                <FlexCol sm={6} md={5} xl={4} className="rec-acct-modal-log-in-confirmation-body">
                    <Heading
                        headingLevel={1}
                        appearance="display"
                        className="rec-acct-modal-title"
                        id="confirmPasswordModalHeading">
                        {this.props.label}
                    </Heading>
                    {error}
                    <form onSubmit={this.submitForm}>
                        <div className="form-item-wrap">
                            <Label
                                htmlFor="rec-acct-password">
                                New Password
                            </Label>
                            <input
                                type="password"
                                ref={(password1) => this.password1 = password1}
                                onChange={(event) => this.password1TextChange(event)}
                                className="rec-acct-password"
                                id="rec-acct-password"
                                autoComplete="off" />
                        </div>
                        <div className="form-item-wrap">
                            <Label
                                htmlFor="rec-acct-password-confirm">
                                Re-Enter Password
                            </Label>
                            <input
                                type="password"
                                ref={(password2) => this.password2 = password2}
                                onChange={(event) => this.password2TextChange(event)}
                                className="rec-acct-password"
                                id="rec-acct-password-confirm"
                                autoComplete="off" />
                        </div>

                        <PasswordStrengthIndicator password={this.state.password1} />

                        <Button
                            shouldFitContainer
                            size="lg"
                            type="submit"
                            className="rec-acct-sign-in-btn"
                            title={this.props.label}
                            isDisabled={disabled}
                            aria-label={this.props.label}>
                            {this.props.label}
                        </Button>
                    </form>
                </FlexCol>
            </FlexRow>
        );
    }
}

ConfirmPasswordForm.propTypes = propTypes;
